import * as Setting from "../Setting";

export function getKeepAlive() {
  return fetch(`${Setting.ServerUrl}/api/get-ss-keepalive?noext=1&psec=${Setting.psec}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => {
    if (res.status === 403) {
      Setting.goToLink("/");
    }
  });
}
